export class Activity {
    name: string;
    noDataMessage: string;
    activityShortCode: string;
    sectionName: string;
}
